<template>
	<div class="vote">
		<section class="vote-top" v-if="screenWidth>1200">
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img src="../assets/images/d-vote-title.png" alt="" class="vote-title"> 
			<img src="../assets/images/d-vote-step.png" alt="" class="vote-step">
			<div class="vote-pd-class-container">
				<div class="vote-pd-class-text" v-for="(ProcuctClass,index) in allProcuctClass" :key="ProcuctClass.engName" v-on:click="changeShowClass(index)">
					<p class="vote-pd-class-eng">{{ ProcuctClass.engName }}</p>
					<h3 class="vote-pd-class-chi">{{ ProcuctClass.chiName }}</h3>
				</div>
			</div>
			<img src="../assets/images/d-vote-hr.png" alt="" class="vote-hr" >
		</section>
		<section class="vote-top" v-else>
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img src="../assets/images/m-vote-title.png" alt="" class="vote-title"> 
			<img src="../assets/images/m-vote-step.png" alt="" class="vote-step">
			<div class="vote-pd-class-container">
				<div class="vote-pd-class-text" v-for="(ProcuctClass,index) in allProcuctClass" :key="ProcuctClass.engName" v-on:click="changeShowClass(index)">
					<p class="vote-pd-class-eng">{{ ProcuctClass.engName }}</p>
					<h3 class="vote-pd-class-chi">{{ ProcuctClass.chiName }}</h3>
				</div>
			</div>
			<img src="../assets/images/m-vote-hr.png" alt="" class="vote-hr">
		</section>

		<section class="vote-container">
			<div class="vote-content">
				<div class="class-title">
					<h4 class="class-eng">{{ currentShowClassEngName }}</h4>
					<h3 class="class-chi">{{ currentShowClassChiName }}</h3>
				</div>
				<!--item templete using v-for when read json data -->
				<div v-for="(product,index) in currentShowProduct" :key="product.id" class="vote-product-item" >
					<div class="product-pic" v-bind:style="{backgroundImage: 'url(' + setImageUrl(product.image) + ')'}" v-bind:class="{ right: ((index+1)%2==0), left: ((index+1)%2!=0) }" v-on:click="toggleModalFlag(product.id)"  data-toggle="modal" data-target="#Modal">
						<div class="current-vote">
						<span>目前票數</span>
						<p class="vote-num" >{{ addCommas(product.vote) }}</p>
						</div>
					</div>
					<div class="product-content">
						<h4 class="brand-name">{{product.brand}}</h4>
						<p class="product-name">{{product.product}}</p>
						<a class="vote-btn" v-on:click="checkCurrentStatus(product.id,currentShowClassEngName)">投它一票</a>
					</div>
				</div>
			</div>

		</section>
		<section class="event-description">
			<ul class="event-list">
				<li>評選說明
					<p>於活動期間 2017/09/11 ~ 09/24，從專業美容老師所評選出 16 個品項的 TOP 10，選擇你喜愛的產品進行投票，與我們共同評選出人氣口碑獎，有機會獲得柯夢波丹為你準備的精美美妝小禮!</p>
				</li>
				<li>活動贈品
					<img src="../assets/images/d-gift.png" alt="" class="gift" v-if="screenWidth>1200">
					<img src="../assets/images/m-gift.png" alt="" class="gift-m" v-else>
				</li>
				<li>得獎權利與義務
					<p>依照中華民國國稅局規定，參加任何活動得獎，獎項價值超過新台幣10,000以上須做得獎申報扣繳，得獎者應先傳真(02-2500-1986)或郵寄提供申報相關文件(身分證正反影本)予主辦單位，始得領取活動獎品。活動獎項價值超過新台幣20,000元者，得獎者應自行負擔10%之機會中獎所得稅。</p>
				</li>
				<li>注意事項
					<ul class="care-list">
						<li>每人限得獎一次，若發現重複得獎，主辦單位得取消其中任一獎項，並由備取者遞補。</li>
						<li>本活動限中華民國台灣地區(台澎金馬地區)之使用者參加，本活動之獎品不得轉換、轉讓或折換現金。</li>
						<li>活動期間如有任何問題，可來信至e-mail:cosmo_service@hearst.com.tw 聯絡。</li>
						<li>參加者於參加活動同時，即同意接受本活動注意事項之規範，如果違反本活動注意事項之行為，主辦單位得取消其參加或得獎資格，並對於任何破壞活動之行為保留相關權利。</li>
						<li>請確認註冊Facebook皆為正確資料，主辦方所有資料皆會保密，只作為參賽者聯繫、聯絡通知或獎品寄送之依據。填寫錯誤資訊以致 聯絡誤差，將視同放棄參賽資格。</li>
						<li>參加者所參與獲提供的活動內容，不符合活動辦法之規範，主辦單位得取消其參加或得獎資格，且不另行通知。</li>
						<li>如果不實或不正確之情事，將被取消參加資格:如為得獎者，則取消得獎資格。如因此致主辦單位無法通知其得獎訊息時，主辦單位不負任何責任。且如有致損害於主辦單位或其他任何第三人，參加者應負一切民刑事責任。</li>
						<li>如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使寄予得獎人之獎品有延遲、遺失、錯誤、無法辨識或毀損之 情況，主辦單位不負任何法律責任，參加者亦不得因此異議。</li>
						<li>活動因故無法進行時，主辦單位有權決定取消、終止、修改或暫停活動。</li>
						<li>活動獎項若因不可抗力因素需要調整，主辦單位保留改以他項等值獎品代替之權利。</li>
					</ul>
				</li>
				<li>得獎名單
					<p>公佈於 2017 10月 柯夢波丹粉絲團。</p>
				</li>
				<li>領獎方式
					<ul class="care-list">
						<li>得獎者應於柯夢波丹通知之一週內回覆確認同意領取獎品，並提供柯夢波丹所要求之完整領獎文件，逾期視為棄權。</li>
						<li>台灣本島與澎湖、金馬地區:獎品將一律以掛號方式配送以避免遺失，得獎者須於名單公佈通知後，須回覆相關配送資料，逾期回覆則視同放棄領獎資格。</li>
					</ul>
				</li>
			</ul>
		</section>
		<Modal v-on:listenSendvote="listenVote()" :modalShownSon="modalShown" :votePageShowPd="currentShowProduct[modalPdId]" :imgUrl="cosmoUrl" :sendPage="'vote'"></Modal>
	</div>
</template>
<script>
import Modal from '../components/Modal'
import axios from 'axios'
var VueScrollTo = require('vue-scrollto')
export default {
	name: 'vote',
	props:{
		cosmoUrl: String,
		allProductData: {},
		allProcuctClass: {},
		screenWidth: Number,
		scrollToInfo : ''
	},
	components:{
		Modal
	},
	data () {
		return {
			currentShowProduct: {},
			currentShowClassEngName: '',
			currentShowClassChiName: '',
			modalShown: false,
			modalPdId: '1',
			initLoginStatus: '',
			userFbProfile: {},
			userChoosePd: 1,
			userChoosePdGroup: 1,
			initFlag: false
		}
	},created(){
		
	},
	watch:{

		modalShown(value){
          let self = this 
          self.modalShown = value
	  },
	  initLoginStatus(val){
		  let self = this 
		  self.initLoginStatus = val
		  self.getProfile()
	  },
	  allProductData(val){
		//   debugger
		  let self = this 
		   self.allProductData = val 
		//   console.log("getAllPd:vote-----")
		 let path = this.$route
		 let pathClass = path.path
		 console.log(pathClass)
		  if(pathClass=='/vote/tovote'){
			  self.checkSession()
			//   debugger
		  }else{
			
			pathClass = pathClass.split('/vote/')[1]
			console.log(pathClass)
			let ids = self.allProcuctClass
			// debugger
			Object.keys(ids).forEach((key)=>{    
					if(ids[key].engName == pathClass )
						self.changeShowClass(key)
				}) 
		  }
			
	  },
	  currentShowProduct(val){
		  let self = this 
		  self.currentShowProduct = val 
		  if(self.initFlag==false)
		  {
			   setTimeout(function(){
					self.scrollEvent()
				},200)
				self.initFlag = true
				// debugger
		  }

	  }
	  
	},
	mounted(){
		let self = this
		self.checkSession()
		
		self.fbInit()
		let path = this.$route
		 let pathClass = path.path
		//  console.log(pathClass)
		  if(pathClass=='/vote/tovote'){
			  self.checkSession()
			//   debugger
		  }else{
			
			pathClass = pathClass.split('/vote/')[1]
			// console.log(pathClass)
			let ids = self.allProcuctClass
			debugger
			Object.keys(ids).forEach((key)=>{    
					if(ids[key].engName == pathClass )
						self.changeShowClass(key)
				}) 
		  }
	},
	methods:{
		fbInit(){
			let app_id = "1773345512896290"; 
			// 目前是測試1717066635240445 上正式機 要替換為 1773345512896290 
			//$("meta[property='fb:app_id']").attr('data-scope')
			//$("meta[property='fb:app_id']").attr("content")
			if(location.href.indexOf("http://c.hearst-taiwan.com.tw/2017/beautyawards/")!=-1){
				app_id = '1717066635240445'
				// console.log("app_id"+app_id)
			}
			window.$fb = new $.facebookr({
				version: 'v2.9',
				appId: app_id,
				scope: 'email,public_profile,user_birthday',
				onLoad: function() {
					
				}
			});   
		},
		scrollEvent(){
			let self = this
			let path = this.$route.path
			// console.log(path)
			if(path.includes('info') == true)
			{
				// 若上方有接資料的div 要先確定抓到資料 否則下方的element會定位有落差
				let scroll_e = VueScrollTo.scrollTo('.event-description')
				// debugger
			}else{
				// if(window.scrollY > 50){
				// 	$('html,body').animate({ scrollTop: 1 }, 100)
				// }
			}
		},
		checkSession(){
			let self = this
			if(typeof sessionStorage.saveClass!=="undefined"){
				// console.log(sessionStorage.saveClass)
				self.changeShowClass(sessionStorage.saveClass)
			}
			else{
				self.changeShowClass(1)
			}
		},
		listenVote: function(){
			// alert("vote")
			let self = this
			self.checkCurrentStatus(self.modalPdId,self.currentShowClassEngName)
		},
		toggleModalFlag: function(pdId){
			let self = this
			if(pdId!= null)
				self.modalPdId = pdId
				// console.log("pdId:"+self.modalPdId)

			self.modalShown = !self.modalShown
			// console.log(self.modalShown)
		},
		setImageUrl: function(productImage){
			let self = this 
			return self.cosmoUrl+'images/'+productImage
		},
		addCommas: function(number) {
			number += ''
			let x = number.split('.')
			let x1 = x[0]
			let x2 = x.length > 1 ? '.' + x[1] : ''
			let rgx = /(\d+)(\d{3})/
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2')
			}
			return x1 + x2
		},
		changeShowClass: function(index) {
			let self = this 
			self.currentShowProduct = self.allProductData[index]
			self.currentShowClassEngName = self.allProcuctClass[index].engName
			self.currentShowClassChiName = self.allProcuctClass[index].chiName
			sessionStorage.saveClass = index
			// console.log(sessionStorage.saveClass)
		},
		login :function() {
			let self = this
			window.$fb.login({}, function(response) {
				if (response.status !== "cancel") {
					self.initLoginStatus = "connected"
					// alert("成功登入")
				}
				else {
					alert("請登入 Facebook")
				}
			});
		},
		getProfile:function() {
 			let self = this
			FB.api('/me?fields=name,id,email,link,gender,birthday', function (response) {
				// console.log('res in graphAPI', response)
				self.userFbProfile = response
				self.doVoting(self.userChoosePd,self.userChoosePdGroup)
				return true
			})

		},
		checkCurrentStatus: function(productId,group){
			// debugger
			let self = this
			self.userChoosePd = productId
			self.userChoosePdGroup = group
			if(self.initLoginStatus!= "connected")
			{
				self.login()
			}else
			{
				self.doVoting(productId,group)
			}
		},
		doVoting:function(productId,group){
			let self = this
			
			// console.log(self.currentShowProduct[productId])
			let ids = self.allProcuctClass
			Object.keys(ids).forEach((key)=>{    
				if(ids[key].engName == group )
					group = key
			})      
			const data = new FormData()
			data.append('fb_id', self.userFbProfile.id)
			data.append('name', self.userFbProfile.name)
			data.append('birthday', self.userFbProfile.birthday)
			data.append("email", self.userFbProfile.email)
			data.append("gender", self.userFbProfile.gender)
			data.append("link", self.userFbProfile.link)
			data.append("group_id", group)
			data.append("item_id", productId)

			axios.post(self.cosmoUrl+'route.php?r=voting',data)
			.then((resp) => {
				// console.log(resp)  			
				if(resp.data.status == "success"){
					alert("投票成功！")
					self.currentShowProduct[productId].vote = self.currentShowProduct[productId].vote+1
				}
			})
			.catch((err) => {
				if(err.response.data.status == "voted")
				{
					alert("您今日已在該類別投票數已達上限!")
				}else if(err.response.data.status == "voting has closed"){
					alert("投票已截止!")
				}
			
			})
		}
	}
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
$main-color: #f21290

.vote
	background-image: url(../assets/images/d-bg.jpg)
	background-position: 50% 0
	background-size: cover
	background-repeat: no-repeat
	background-attachment: fixed
	padding-bottom: 100px
.vote-top
	width: 100%
	position: relative
	overflow: hidden
	padding-top: 21px
	// background-color: #000
	z-index: 1
	padding-top: 64px
	&:after
		content: ''
		position: absolute
		z-index: -1
		top: 0
		left: calc(50% - 1280px)
		height: 684px
		width: 2560px
		background-image: url(../assets/images/d-page-kv.png)
		background-position: 50% 0
		background-size: cover
		background-repeat: no-repeat
		
		
	.bw-logo
		height: 54px
		position: absolute
		top: 21px
		left: calc(50% - 600px)
		img 
			height: 100%
	.vote-title
		margin: 0 auto
		margin-bottom: 20px
		margin-top: -10px
	.vote-step
		margin: 0 auto
		margin-bottom: (22px-13px)


.vote-pd-class-container
	width: 800px
	margin: 0 auto
	display: flex
	flex-direction: row
	justify-content: center
	flex-wrap: wrap
	.vote-pd-class-text
		flex-grow: 1
		width: calc(100% * (1/8))
		padding: 13px 0
		color: $main-color
		cursor: pointer
		text-align: center
	.vote-pd-class-eng 
		font-size: 13px
		font-weight: 300
		line-height: 1.69
		letter-spacing: 0.3px
	.vote-pd-class-chi
		font-size: 18px
		font-weight: bold
		line-height: 1.22
		letter-spacing: normal
.vote-hr
	margin: 0 auto
	margin-top: (29px - 13px)
	margin-bottom: 50px
.vote-container
	// background: linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
.vote-content
	width: 1236px
	height: 1528px
	display: flex
	flex-direction: row
	justify-content: flex-start
	align-content: flex-start
	flex-wrap: wrap
	padding-bottom: (151px - 30px)
	margin: 0 auto
	.class-title,
	.vote-product-item
		height: 430px
		width: 297px
		margin: 0 6px
		margin-bottom: 39px

.class-title
	// flex: 1
	background-image: url(../assets/images/d-vote-category-bg.png)
	background-position: 50% 0
	background-size: 100%
	background-repeat: no-repeat
	color: $main-color
	text-align: center
	padding-top: 124px
	.class-eng
		font-size: 31px
		font-weight: 300
		line-height: 1.69
		letter-spacing: 0.8px
	.class-chi
		font-size: 42.9px
		font-weight: bold
		line-height: 1.22
		letter-spacing: 1.1px
		display: inline-block
		position: relative
		&:after 
			content: ''
			position: absolute
			bottom: -31px
			left: 0
			width: 100%
			height: 1px
			background-color: $main-color 

.vote-product-item
	.product-pic
		width: 100%
		height: 297px
		background-image: url(../assets/images/pd-base-01.jpg)
		background-position: center center
		background-size: cover 
		background-repeat: no-repeat
		position: relative
		&:hover
			&:after
				opacity: 1
				visibility: visible
		&:after
			content: ''
			position: absolute
			top: 0
			left: 0
			width: 100%
			height: 100%
			background-image: url(../assets/images/d-vote-pd-border.png)
			background-position: 50% 50%
			background-size: 100%
			background-repeat: no-repeat
			opacity: 0
			visibility: hidden
			z-index: 5
			cursor: pointer
			transition: opacity .35s, visibility .35s, height .35s
.current-vote
	background-image: url(../assets/images/vote-pd-tringle-bg.png)
	background-position: 100% 0
	background-repeat: no-repeat
	background-size: 100%
	width: 193px
	height: 146px
	z-index: 2
	position: absolute
	top: 0
	right: 0
	padding: 22px 19px 0 0
	span 
		color: #fff
		font-size: 14px
		font-weight: 300
		line-height: 1.79
		text-align: right
		display: block
	.vote-num
		color: #fff
		font-size: 24px
		font-weight: 500
		line-height: 1.04
		text-align: right
		color: #ffffff  
.product-content
	padding-top: 12px
	text-align: center
	>.brand-name
		font-size: 18px
		font-weight: 300
		line-height: 1.55
		color: #ffffff
		position: relative
		display: inline-block
		margin: 0 auto
		&:after 
			content: ''
			position: absolute
			bottom: -8px
			width: 50%
			left: 25%
			height: 1px
			background-color: $main-color
	>.product-name
		margin-top: 18px
		margin-bottom: 16px
		font-size: 16px
		text-align: center
		color: #ffffff
.vote-btn
	width: 166px
	height: 35px
	text-align: center
	font-size: 16px
	line-height: 35px
	font-weight: 300
	cursor: pointer
	color: #fff !important
	position: relative
	z-index: 2
	margin: 0 auto
	&:before
		font-family: FontAwesome
		content: "\f08a"
		text-align: right
		position: absolute
		padding-right: 30px
		top: 0
		left: 0
		width: 100%
		height: 100%
		background-color: $main-color
		transition: opacity .5s ease-in-out
		z-index: -1
	&:after 
		font-family: FontAwesome
		content: "\f004"
		text-align: right
		position: absolute
		padding-right: 30px
		top: 0
		left: 0
		width: 100%
		height: 100%
		z-index: -1
		transition: opacity .35s ease-in-out
		background-image: linear-gradient(to right, #e4007f, #ff2fc1 49%, #af1dd0)
		opacity: 0
	&:hover,
	&:active
		&:after 
			opacity: 1
			

.event-description
	width: 1220px
	height: 1430px 
	background-image: url(../assets/images/d-event-border.png)
	background-position: 0 0
	background-repeat: no-repeat
	background-size: contain
	margin: 0 auto
	padding: 74px 107px 91px 107px 
	>.event-list
		>li 
			font-size: 24px
			font-weight: 500
			line-height: 1.6
			letter-spacing: 0.6px
			text-align: left
			color: #d9c476
			position: relative
			margin-bottom: 38px
			&:after 
				content: "\f0de"
				font-family: FontAwesome
				color: #d9c476
				font-size: 14px
				position: absolute
				left: -20px
				top: 10px
				transform: rotate(90deg)
			p 	
				padding-top: 12px

		p,
		.care-list li
			color: #ffffff
			font-size: 16px
			line-height: 1.56
			letter-spacing: 0.4px
			text-align: justify
		.care-list 
			list-style-type: disc
			padding-left: 24px
			padding-top: 12px

		.gift 
			padding-top: 26px
+rwd(1200px)
	.vote-top 
		width: 100%		
		background-image: url(../assets/images/m-page-kv-n.jpg)
		background-position: 50% 0	
		background-size: 100%
		background-color: transparent
		background-repeat: no-repeat
		padding: 0
		&:after 
			display: none
		.bw-logo 
			height: auto 
			left: 35px
		.vote-title 
			padding-top: 144px
			margin-bottom: 20px
		.vote-step 
			width: 100%
			max-width: 750px
			margin-bottom: 18px
	.vote-container
		width: 100%		
		background: none
	.vote-pd-class-container
		width: 100%
		.vote-pd-class-text
			// width: calc(100% * (1/6))
			width: auto
			margin: 0 18px
		.vote-pd-class-eng 
			font-size: 18.6px
			font-weight: 300
			line-height: 1.67
			letter-spacing: 0.5px
		.vote-pd-class-chi
			font-size: 29.5px
			font-weight: bold
			line-height: 1.05
	.vote-hr
		margin-bottom: 0
		margin-top: 38px 
	.vote-content
		width: 100%
		max-width: 750px
		height: 3536px
		padding: 0 5%
		.class-title
			width: 100%
			max-width: 650px	
			margin: 0 auto
			background-image: url(../assets/images/m-vote-class-bg.png)
			background-position: 50% 50%
			background-size: 100%
			background-repeat: no-repeat
			color: #fff
			text-align: center
			padding: 0
			height: 232px
			display: flex
			justify-content: center 
			align-items: center
			flex-direction: column
			.class-eng 
				font-size: 38.4px
				font-weight: 300
				line-height: 1.69
				letter-spacing: 1px
			.class-chi
				font-size: 53.1px
				line-height: 1.22
				letter-spacing: 1.3px
				font-weight: 400
				&:after 
					opacity: 0
					
		.vote-product-item
			height: 622px
			width: 320px
			padding-bottom: 0
			position: relative
			.product-pic
				width: 320px
				height: 321px
				&:after 
					background-image: url(../assets/images/m-vote-pd-border.png)
					background-position: center center
					background-size: 100% 
					background-repeat: no-repeat
					opacity: 1
					visibility: visible
					height: 100%
				&:hover
					&:after 
						opacity: 1
						visibility: visible
						height: 100%
				

		.product-content
			padding-top: 21px
		.brand-name
			font-size: 28px
			font-weight: 300
			line-height: 1.2
		.product-name
			font-size: 30px
			margin: 26px auto 30px
	.vote-btn
		position: absolute
		bottom: 71px
		left: 0
		width: 320px
		height: 60px
		font-size: 28px
		line-height: 60px
	.event-description
		background: none
		padding: 0 5%
		width: 100%
		height: auto
		padding-bottom: 10%
		>.event-list 
			>li 
				font-size: 34px
				letter-spacing: 0.9px
				font-weight: 300
				&:after 
					font-size: 18px
					top: 14px
				p,
				.care-list li  
					font-size: 28px
					line-height: 1.43
					padding-top: 8px
					font-weight: 300
				.care-list li 
					padding-top: 0
			
	.current-vote
		span
			font-size: 20px
			line-height: 1.2
		.vote-num 
			font-size: 38px
			line-height: 1.2

</style>



// WEBPACK FOOTER //
// Vote.vue?d36cf882